import {Component, OnInit, Inject, Optional, inject, DestroyRef} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {ContactService} from '../../../services/api/contact.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {FormUtilService} from '../../../services/util/form-util.service';
import {SidenavService} from '../../../services/util/sidenav.service';
import {AuthService} from 'src/app/services/auth/auth.service';
import {AnimationsService} from '../../../services/util/animations.service';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-contact-us-dialog',
    templateUrl: './contact-us-dialog.component.html',
    styleUrls: ['./contact-us-dialog.component.scss'],
    animations: [AnimationsService.ENTER_EASE_OUT_FROM_RIGHT('successMessage')],
    standalone: false
})
export class ContactUsDialogComponent  implements OnInit {
  contactUsForm: UntypedFormGroup;
  sent: boolean;
  typedMessage = '';
  displayTooltip = false;
  messageSentTry = false;
  sendBtnClicked = false;
private destroyRef = inject(DestroyRef);
  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data: any, @Optional() public matdialogRef: MatDialogRef<ContactUsDialogComponent>, public sidenavService: SidenavService, private formBuilder: UntypedFormBuilder, private contactService: ContactService,
              private authService: AuthService) {
    
  }

  ngOnInit(): void {
    this.buildForm();
  }

  copyText(): void {
    const textToCopy = document.getElementById('text-content') as HTMLInputElement;
    textToCopy.select();
    textToCopy.setSelectionRange(0, 99999);
    document.execCommand('copy');
    this.displayTooltip = true;
    setTimeout(() => {
      this.displayTooltip = false;
    }, 5000);
  }

  sendMessage(): void {
    if (!FormUtilService.validateForm(this.contactUsForm)) {
      return;
    }
    this.typedMessage = this.contactUsForm.get('message').value;
    this.sendBtnClicked = true;
    this.contactService.sendMessage(this.contactUsForm.getRawValue())
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
          this.sent = true;
          this.messageSentTry = true;
        },
        (error) => {
          this.sent = false;
          this.messageSentTry = true;
        }
      );
  }

  private buildForm(): void {
    const userInfo = this.authService.principal;
    const companyName = userInfo.attributes.issuerName || userInfo.attributes.issuerId || userInfo.provider;
    this.contactUsForm = this.formBuilder.group({
      name: [userInfo.attributes.name, Validators.required],
      email: [userInfo.attributes.email, Validators.required],
      company: [companyName, Validators.required],
      message: ['', Validators.required]
    });
  }

}
